export const formatString = (str, defaultValue) => {
  const toString = str && String(str);
  return toString || defaultValue || '';
};
